import styled from 'styled-components';
import { mediaQuery } from '../../services/settings.json';

export const Frame = styled.iframe`
	width: 100%;
	
	border: none;
	border-radius: 8px;
	@media screen and (min-width: ${mediaQuery.laptop}px) {
		height: 360px;
	}
	@media screen and (min-width: ${mediaQuery.desktop}px) {
		height: calc(360px * 1.5);
	}
`;
